import { ApolloLink, Observable } from '@apollo/client';
import { makeExecutableSchema } from '@graphql-tools/schema';
import { graphql, print } from 'graphql';
import schemaText from '../../schemas.gql';
import resolvers from './resolvers';
// Build schema
let schema = null;
function buildOfflineSchema() {
    if (!schema) {
        schema = makeExecutableSchema({
            typeDefs: schemaText,
            resolvers,
        });
    }
    return schema;
}
// Create offline server link
const offlineServerLink = new ApolloLink((operation) => {
    return new Observable((observer) => {
        (async () => {
            const { query, variables, operationName } = operation;
            try {
                const offlineSchema = buildOfflineSchema();
                // Convert the query to a string to ensure fragments are resolved
                const queryString = print(query);
                const result = await graphql({
                    schema: offlineSchema,
                    source: queryString,
                    variableValues: variables,
                    operationName,
                });
                if (result.errors && result.errors.length > 0) {
                    observer.error(new Error(result.errors[0].message));
                }
                else {
                    observer.next(result);
                    observer.complete();
                }
            }
            catch (error) {
                console.error('[offlineServerLink] error', {
                    query,
                    variables,
                    operationName,
                    error,
                });
                observer.error(error);
            }
        })();
    });
});
export default offlineServerLink;
